import { trackSectionCtaClick } from "@/lib/analytics";
import ScoreInlineForm from "@/components/ScoreInlineForm";

const coreServices = [
  {
    title: "Agentic AI Lead Generation",
    description: "Human-governed agent workflows for research, qualification and commercial follow-through.",
    href: "/services/gemini-agentic-ai/",
    accent: "#FF8C00",
  },
  {
    title: "AEO, GEO and AI Search",
    description: "Clear, evidence-led pages that help buyers and answer systems understand your offer.",
    href: "/services/seo-aeo-geo/",
    accent: "#00D4AA",
  },
  {
    title: "PPC and Conversion Optimisation",
    description: "Paid-media and landing-page decisions tied to the same persona and commercial evidence.",
    href: "/services/ppc-performance-max/",
    accent: "#A78BFA",
  },
];

export default function Hero() {
  return (
    <section
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(135deg, #0F1419 0%, #1a1f2e 100%)" }}
      aria-labelledby="hero-heading"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_85%_10%,rgba(255,140,0,0.16),transparent_32%),radial-gradient(circle_at_30%_100%,rgba(0,212,170,0.12),transparent_38%)]" aria-hidden="true" />
      <div className="container relative z-10 pt-24 pb-14 sm:pt-28 sm:pb-16 lg:pt-32 lg:pb-20">
        <div className="max-w-5xl">
          <span className="text-mono text-[#FF8C00] tracking-widest text-xs uppercase font-semibold">London AI Marketing Growth Agency · B2B, B2C and ecommerce</span>
          <h1 id="hero-heading" className="mt-4 text-display text-3xl leading-[1.04] sm:text-4xl lg:text-6xl text-white speakable-intro">
            Turn AI Search visibility into revenue
          </h1>
          <h2 className="mt-4 font-serif text-xl sm:text-2xl lg:text-3xl leading-tight text-[#00D4AA] speakable-intro">
            London AI Marketing Growth & AEO Agency
          </h2>
          <p className="mt-5 max-w-4xl text-white/80 text-base sm:text-lg leading-relaxed speakable-intro" id="entity-declaration">
            Integrated.Social is a London AI Marketing Growth Agency for B2B, B2C and ecommerce brands. We run one persona plan across answer-engine visibility, generative-engine consistency, paid media, and agentic lead gen, so the claim an AI answer repeats is the same claim a person signed. Agents draft. A person signs. That is not a promise to be first in AI answers.
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <div className="w-full max-w-xl"><ScoreInlineForm placement="hero" /></div>
            <a
              href="https://calendly.com/modielnadi/30min"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackSectionCtaClick({ section_name: "hero", cta_text: "Book a 30-min discovery call", destination: "https://calendly.com/modielnadi/30min" })}
              className="inline-flex min-h-12 items-center justify-center border border-white/30 px-6 py-3 text-sm font-semibold text-white rounded-sm transition-colors hover:border-[#00D4AA] hover:text-[#00D4AA]"
            >
              Book a 30-min discovery call
            </a>
          </div>
          <p className="mt-3 text-xs text-white/50">Free 0–100 AI Visibility Score. A paid diagnostic is a separate, senior-led service.</p>

          <section aria-labelledby="hero-services-heading" className="mt-10 border-t border-white/10 pt-6">
            <h2 id="hero-services-heading" className="sr-only">Three connected AI marketing services</h2>
            <div className="grid gap-3 md:grid-cols-3">
              {coreServices.map((service) => (
                <a key={service.href} href={service.href} className="group rounded-sm border border-white/10 bg-white/[0.04] p-4 transition-colors hover:bg-white/[0.08]" style={{ borderLeftColor: service.accent, borderLeftWidth: "3px" }}>
                  <h3 className="font-serif text-base text-white group-hover:text-white">{service.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/55">{service.description}</p>
                  <span className="mt-3 inline-block text-xs font-semibold" style={{ color: service.accent }}>Explore service →</span>
                </a>
              ))}
            </div>
          </section>
        </div>
      </div>
    </section>
  );
}
